import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Modal from 'shared/components/Modal';
import { FormattedMessage } from 'react-intl';
// import cx from 'classnames';

import withSliderLogic from 'shared/hocs/withSliderLogic';
import FullScreenSlider from 'desktop/components/FullScreenSlider/FullScreenSlider';

import { imageBgStyle } from '../../../../../shared/helpers/common';

import s from './DealerImages.css';

const MAX_IMAGE_COUNT = 7;

class DealerImages extends React.Component {
  static propTypes = {
    photos: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.number.isRequired, image: PropTypes.string.isRequired }),
    ),
    index: PropTypes.number,
    id: PropTypes.number,
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    // methods
    setFullscreenImage: PropTypes.func.isRequired,
    setPrevId: PropTypes.func.isRequired,
    setNextId: PropTypes.func.isRequired,
    closeSlider: PropTypes.func.isRequired,
  };

  static defaultProps = {
    photos: [],
    index: 0,
    id: null,
  };

  render() {
    const {
      photos,
      // hoc:
      id: currentId,
      left,
      // methods:
      setFullscreenImage,
      setPrevId,
      setNextId,
      closeSlider,
    } = this.props;

    const fullscreenSliderMethods = {
      setPrevId,
      setNextId,
      closeSlider,
      setFullscreenImage,
    };

    const overhead = photos.length > MAX_IMAGE_COUNT ? photos.length - MAX_IMAGE_COUNT : null;

    return (
      <div className={s.root}>
        <div className={s.container}>
          {photos.map(({ image, id }, i) => {
            const imageStyles = {
              ...imageBgStyle(image),
              display: i >= MAX_IMAGE_COUNT ? 'none' : null,
            };

            return (
              <div
                id={id}
                onClick={setFullscreenImage}
                key={id || image}
                style={imageStyles}
                className={s.image}
              >
                {overhead &&
                  i === MAX_IMAGE_COUNT - 1 &&
                  <span id={id} className={s.morePhotos}>
                    <FormattedMessage id="Ещё" /> {` ${overhead}`}
                  </span>}
              </div>
            );
          })}
        </div>
        {currentId &&
          <Modal>
            <FullScreenSlider
              photos={photos}
              id={currentId}
              left={left}
              {...fullscreenSliderMethods}
            />
          </Modal>}
      </div>
    );
  }
}

export default withSliderLogic(withStyles(s)(DealerImages));



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/components/DealerImages/DealerImages.js